export default "__VITE_ASSET__urHvBmJg__"